import { ShieldCheck, Sparkles, Star, Clock, MapPin, Users } from "lucide-react";

const REASONS = [
  {
    icon: ShieldCheck,
    title: "Versichert & zertifiziert",
    text: "Branchenübliche Versicherungen und geprüfte Reinigungsverfahren — Sicherheit, die sich rechnet.",
  },
  {
    icon: Sparkles,
    title: "Höchste Sorgfalt",
    text: "Jeder Auftrag wird individuell geplant. Wir reinigen so, als wäre es unser eigenes Objekt.",
  },
  {
    icon: Star,
    title: "Fünf-Sterne-Anspruch",
    text: 'Wir geben uns nicht mit „sauber genug" zufrieden. Unser Maßstab: makellos.',
  },
  {
    icon: Clock,
    title: "Antwort in 24 Stunden",
    text: "Auf Ihre Anfrage reagieren wir in der Regel innerhalb eines Werktages mit einem konkreten Vorschlag.",
  },
  {
    icon: MapPin,
    title: "Deutschlandweit verfügbar",
    text: "Schwerpunkt Baden-Württemberg — auf Wunsch betreuen wir Sie aber bundesweit.",
  },
  {
    icon: Users,
    title: "Persönlicher Ansprechpartner",
    text: "Der Geschäftsführer Wallat Ramo ist Ihr direkter Kontakt — keine anonymen Hotlines.",
  },
];

export default function WarumWir() {
  return (
    <section id="warum-wir" data-testid="warum-wir-section" className="relative py-24 md:py-32 bg-ink-800">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <p className="text-xs tracking-[0.3em] uppercase text-gold mb-5">Warum wir</p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight leading-tight">
              Sechs Gründe für<br />
              <span className="italic text-gold-soft">Five Star.</span>
            </h2>
            <p className="mt-6 text-zinc-400 max-w-md">
              Sauberkeit ist kein Detail — sie ist die Visitenkarte Ihres Unternehmens.
              Wir behandeln sie auch so.
            </p>
          </div>

          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-px bg-ink-500/40">
            {REASONS.map((r, idx) => {
              const Icon = r.icon;
              return (
                <div
                  key={r.title}
                  data-testid={`reason-${idx}`}
                  className="bg-ink-800 p-8 hover:bg-ink-700 transition-colors duration-500 group"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <Icon size={22} className="text-gold" />
                    <span className="text-[10px] text-zinc-500 tracking-[0.3em] uppercase">
                      0{idx + 1}
                    </span>
                  </div>
                  <h3 className="font-display text-xl text-white mb-3 group-hover:text-gold-soft transition-colors">
                    {r.title}
                  </h3>
                  <p className="text-sm text-zinc-400 leading-relaxed">{r.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
